module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-card"
  }, [_c('a', {
    on: {
      "click": _vm.navigate
    }
  }, [(_vm.icon) ? _c('div', {
    staticClass: "dashboard-header"
  }, [_c('img', {
    attrs: {
      "src": _vm.icon
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dashboard-body"
  }, [_vm._t("title", [_c('div', {
    staticClass: "dashboard-card-title-wrapper"
  }, [_c('p', {
    staticClass: "dashboard-card-title"
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _vm._t("description", [_c('p', {
    staticClass: "mt20 fs14"
  }, [_vm._v(_vm._s(_vm.description))])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75519bc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardCard.vue
// module id = 651
// module chunks = 1